export default function MySQL_DEFAULT() {
  return (
    <div>
      <h2>MySQL_DEFAULT</h2>    </div>
  );
}